export default "__VITE_PUBLIC_ASSET__9a77deca__"